// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"407":"panel","441":"superadmin","884":"admin"}[chunkId] + "." + {"407":"97f2bca8","441":"75125316","884":"fab14ce9"}[chunkId] + ".css";
};